module.exports = __webpack_public_path__ + "img/drone_mini1.b071ab44.svg";